var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":_vm.requestItem}},[_c('vue-json-to-csv',{attrs:{"json-data":_vm.dataJson,"labels":{
        serviceName: { title: 'Serviço' },
        date: { title: 'Data e Hora' },
        nameBySalesman: { title: 'Nome do Vendedor' },
        amount: { title: 'valor' },
        paymentType: { title: 'Tipo de Pagamento' }
      },"csv-title":'Relatorio',"separator":';'},on:{"success":function (val) { return _vm.handleSuccess(val); },"error":function (val) { return _vm.handleError(val); }}},[_c('button',{class:"downloadCsv"},[_c('font-awesome-icon',{attrs:{"icon":"fa-solid fa-download"}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }